var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "m-2 mx-0 message",
      class: _vm.messageClass,
      attrs: {
        title: _vm.messageTimeLocalize,
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "actor",
        },
        [_vm._v(_vm._s(_vm.message.sender_name))]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "mt-1 mb-0 text-light p-2 px-3 rounded message-text",
        },
        [
          _vm._v("\n    " + _vm._s(_vm.message.message) + "\n    "),
          _c("span", {
            staticClass: "caret",
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "text-xs text-muted",
        },
        [_vm._v(_vm._s(_vm.messageTimeHumanize))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }